"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinearProgress = void 0;
var colors_1 = require("../ThemeProvider/colors");
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var styles_1 = require("@mui/material/styles");
exports.StyledLinearProgress = (0, styles_1.styled)(LinearProgress_1.default)(function (_a) {
    var color = _a.color;
    return ({
        minWidth: '40px',
        backgroundColor: colors_1.tannerGray['200'],
        '& .MuiLinearProgress-bar': __assign({}, (color === undefined && { backgroundColor: colors_1.tannerBlue['500'] })),
    });
});
//# sourceMappingURL=styles.js.map